/**
 * solarpanel计算器轻便型 icon
 */
export const EFCalculateIcon1 = () => (
    <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g transform="translate(-450.000000, -1170.000000)">
                <g id="编组-10" transform="translate(400.000000, 1030.000000)">
                    <g id="编组-6" transform="translate(0.000000, 100.000000)">
                        <g id="便携_icon" transform="translate(50.000000, 40.000000)">
                            <rect id="矩形" x="0" y="0" width="42" height="42"></rect>
                            <path
                                d="M21.9952607,3 C24.960216,3 27.4415393,5.12813589 27.9653545,7.9730889 L37.9194313,7.97237569 C40.1730672,7.97237569 42,9.7978666 42,12.0497238 L42,34.9226519 C42,37.1745091 40.1730672,39 37.9194313,39 L4.08056872,39 C1.82693285,39 0,37.1745091 0,34.9226519 L0,12.0497238 C0,9.7978666 1.82693285,7.97237569 4.08056872,7.97237569 L14.032009,7.97287035 C14.5472675,5.14443689 17.0253756,3 20.0047393,3 L21.9952607,3 Z M3.91005291,10 C2.85515982,10 2,10.8570072 2,11.9141791 L2,35.0858209 C2,36.1429928 2.85515982,37 3.91005291,37 L38.0899471,37 C39.1448402,37 40,36.1429928 40,35.0858209 L40,11.9141791 C40,10.8570072 39.1448402,10 38.0899471,10 L3.91005291,10 Z M20,26 L20,28 L10,28 L10,26 L20,26 Z M32,23 L32,25.1153846 L24.2,25.1153846 L24.2,28 L22,28 L22,23 L32,23 Z M20,22 L20,24 L10,24 L10,22 L20,22 Z M20,19 L20,21 L10,21 L10,19 L20,19 Z M32,19 L32,21 L22,21 L22,19 L32,19 Z M21.996098,5 L20.0981647,5 C18.4374234,5 17.0321682,6.23502701 16.5635829,7.93599211 L16.5471314,8 L25.5471314,8 L25.5372773,7.95925103 C25.0923756,6.30898861 23.7675471,5.09631384 22.1869566,5.00547239 L21.996098,5 Z"
                                id="形状结合"
                                fill="#03060B"
                                fillRule="nonzero"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * solarpanel计算器快充 icon
 */
export const EFCalculateIcon2 = () => (
    <svg width="42px" height="42px" viewBox="0 0 42 42" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
        <g id="太阳能板计算器" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
            <g id="太阳能销售逻辑2" transform="translate(-1025.000000, -1170.000000)">
                <g id="编组-10" transform="translate(400.000000, 1030.000000)">
                    <g id="编组-6" transform="translate(0.000000, 100.000000)">
                        <g id="快速回充_icon" transform="translate(625.000000, 40.000000)">
                            <rect
                                id="矩形备份"
                                transform="translate(21.000000, 21.000000) rotate(90.000000) translate(-21.000000, -21.000000) "
                                x="1.0658141e-14"
                                y="0"
                                width="42"
                                height="42"
                            ></rect>
                            <path
                                d="M21.509,27.099 L20.774,29.399 L5.28173077,29.4 C4.68430736,29.4 4.2,28.8851275 4.2,28.25 C4.2,27.6148725 4.68430736,27.1 5.28173077,27.1 L21.509,27.099 Z M16.123,17.799 L14.467,20.099 L2.625,20.1 C2.00367966,20.1 1.5,19.5851275 1.5,18.95 C1.5,18.3148725 2.00367966,17.8 2.625,17.8 L16.123,17.799 Z M22.816,8.5 L21.16,10.8 L6.10961538,10.8 C5.5520202,10.8 5.1,10.2851275 5.1,9.65 C5.1,9.01487254 5.5520202,8.5 6.10961538,8.5 L22.816,8.5 Z"
                                id="形状"
                                fill="#03060B"
                                fillRule="nonzero"
                            ></path>
                            <path
                                d="M34.3058698,1.17639731 L18.6188731,23.3618567 C18.4401388,23.5723529 18.4658868,23.8878865 18.676383,24.0666209 C18.7667552,24.1433568 18.8814541,24.1854838 19.0000102,24.1854838 L28.3403866,24.1854838 L22.8695033,40.3041285 C22.7718637,40.5624328 22.9021082,40.8509823 23.1604126,40.9486219 C23.3586803,41.0235675 23.5826586,40.9653577 23.719347,40.8033601 L40.2255751,18.6853656 C40.4036535,18.4743142 40.3769236,18.1588622 40.1658723,17.9807838 C40.0756706,17.9046744 39.9614538,17.8629261 39.8434327,17.8629261 L30.8424186,17.8629261 L35.1563501,1.6724103 C35.2515562,1.41319916 35.1186038,1.12588724 34.8593927,1.03068117 C34.6625829,0.958394591 34.4415764,1.01657504 34.3058698,1.17639731 Z"
                                id="路径-9备份-5"
                                fill="#03060B"
                                fillRule="nonzero"
                            ></path>
                        </g>
                    </g>
                </g>
            </g>
        </g>
    </svg>
);

/**
 * solarpanel计算器推荐商品图标（点赞）
 */
export const EFCalculateIcon3 = () => {
    return (
        <svg width="15px" height="16px" viewBox="0 0 15 16" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="太阳能板计算器" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="太阳能销售逻辑3" transform="translate(-442.000000, -756.000000)" fill="#f03e3e" fillRule="nonzero">
                    <g id="编组-15" transform="translate(400.000000, 716.000000)">
                        <g id="编组-3" transform="translate(42.000000, 36.000000)">
                            <g id="icon_点赞-面备份-2" transform="translate(0.000000, 4.000000)">
                                <path
                                    d="M1.27958515,15.9999535 C0.685802567,15.9999535 0,15.3481298 0,14.7512923 L0,14.7512923 L0,6.97128474 C0,6.37408313 0.685802567,5.80382842 1.27958515,5.80382842 L1.27958515,5.80382842 L3.44422875,5.80382842 C4.11445314,5.07553377 5.52518488,3.68740417 6.03636684,1.93439895 C6.04658217,1.88621101 6.0997212,1.66678357 6.16476673,1.41618534 L6.23263232,1.16038457 C6.25581127,1.07511272 6.27916438,0.991565168 6.30154287,0.914929658 C6.41343532,0.531752113 6.53039682,0.338476825 6.56022871,0.313943351 C6.80033633,0.111251122 7.10383703,0.000108443997 7.41739135,4.83582143e-05 C7.70171541,-0.00238352478 7.9793108,0.0869652811 8.20934298,0.254951476 C8.31914088,0.335713349 8.41675762,0.431992582 8.49916973,0.540807133 C9.05346341,1.18607619 9.38459048,2.28434452 9.38459048,3.47000821 C9.38459048,4.35670695 9.19547853,5.15673862 8.85420751,5.81220381 L8.85420751,5.81220381 L8.87594452,5.80382842 L13.890672,5.80382842 C14.1841216,5.80382842 14.4638045,5.97206448 14.6572638,6.19565094 C14.8554329,6.42397132 14.9445546,6.79030352 14.9032543,7.0925458 L14.9032543,7.0925458 L13.7294559,14.9883522 C13.6486667,15.5119961 13.1900158,15.9999535 12.6628934,15.9999535 L12.6628934,15.9999535 Z"
                                    id="形状"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

/**
 * solarpanel计算器火爆商品图标（火）
 */
export const EFCalculateIcon4 = () => {
    return (
        <svg width="13px" height="17px" viewBox="0 0 13 17" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="太阳能板计算器" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="太阳能销售逻辑3" transform="translate(-1030.000000, -756.000000)" fill="#FB8814" fillRule="nonzero">
                    <g id="编组-15" transform="translate(400.000000, 716.000000)">
                        <g id="编组-13" transform="translate(630.000000, 36.000000)">
                            <g id="火" transform="translate(0.000000, 4.000000)">
                                <path
                                    d="M11.4527471,3.69379073 C9.26026908,4.35793193 8.85861281,6.2409845 8.99988995,7.43723017 C7.43582689,5.48366207 7.49984868,3.23687886 7.49984868,0 C2.4832586,2.00933294 3.64995736,7.80311945 3.50009629,9.56241006 C2.238259,8.465102 1.99969737,5.84379498 1.99969737,5.84379496 C0.66775801,6.57197579 0,8.51654955 0,10.093795 C0,13.9081097 2.9099513,17 6.50017883,17 C10.0900487,17 13,13.9081097 13,10.093795 C13,7.82722424 11.4334333,6.78136375 11.4527471,3.69343096 L11.4527471,3.69379073 Z"
                                    id="路径"
                                ></path>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

/**
 * solarpanel计算器充电时间图标（钟表）
 */
export const EFCalculateIcon5 = () => {
    return (
        <svg width="15px" height="15px" viewBox="0 0 15 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="太阳能板计算器" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="太阳能销售逻辑3" transform="translate(-442.000000, -1209.000000)" fill="#919191" fillRule="nonzero">
                    <g id="编组-15" transform="translate(400.000000, 716.000000)">
                        <g id="编组-14" transform="translate(42.000000, 73.000000)">
                            <g id="编组-10" transform="translate(0.000000, 416.000000)">
                                <g id="time-line备份-3" transform="translate(0.000000, 4.000000)">
                                    <path
                                        d="M7.5,0 C11.64225,0 15,3.35775 15,7.5 C15,11.64225 11.64225,15 7.5,15 C3.35775,15 0,11.64225 0,7.5 C0,3.35775 3.35775,0 7.5,0 Z M8.25,3.75 L6.75,3.75 L6.75,9 L11.25,9 L11.25,7.5 L8.25,7.5 L8.25,3.75 Z"
                                        id="形状结合"
                                    ></path>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

/**
 * solarpanel计算器占地面积图标（map）
 */
export const EFCalculateIcon6 = () => {
    return (
        <svg width="13px" height="15px" viewBox="0 0 13 15" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="太阳能板计算器" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="太阳能销售逻辑3" transform="translate(-1317.000000, -1209.000000)" fill="#919191" fillRule="nonzero">
                    <g id="编组-15" transform="translate(400.000000, 716.000000)">
                        <g id="编组-14" transform="translate(630.000000, 73.000000)">
                            <g id="编组-10" transform="translate(0.000000, 416.000000)">
                                <g id="编组-6" transform="translate(287.000000, 0.000000)">
                                    <g id="map-pin-line备份-2" transform="translate(0.000000, 4.000000)">
                                        <path
                                            d="M6.5,15 L11.0964286,10.6063776 C13.6346459,8.17990526 13.6345059,4.24603769 11.0961159,1.81973044 C8.5577259,-0.606576813 4.4422741,-0.606576813 1.90388409,1.81973044 C-0.634505924,4.24603769 -0.634645905,8.17990526 1.90357143,10.6063776 L6.5,15 Z M6.5,8.34299631 C7.73080601,8.34299631 8.72857143,7.38925485 8.72857143,6.21275513 C8.72857143,5.03625542 7.73080601,4.08251395 6.5,4.08251395 C5.26919399,4.08251395 4.27142857,5.03625542 4.27142857,6.21275513 C4.27142857,7.38925485 5.26919399,8.34299631 6.5,8.34299631 Z M6.5,9.4081169 C4.65379098,9.4081169 3.15714286,7.97750471 3.15714286,6.21275513 C3.15714286,4.44800556 4.65379098,3.01739337 6.5,3.01739337 C8.34620902,3.01739337 9.84285714,4.44800556 9.84285714,6.21275513 C9.84285714,7.97750471 8.34620902,9.4081169 6.5,9.4081169 Z"
                                            id="形状"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};

/**
 * solarpanel计算器占地面积图标（map）
 */
export const EFCalculateIcon7 = () => {
    return (
        <svg width="14px" height="14px" viewBox="0 0 14 14" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
            <g id="太阳能板计算器" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                <g id="太阳能销售逻辑3" transform="translate(-442.000000, -1245.000000)" fill="#919191" fillRule="nonzero">
                    <g id="编组-15" transform="translate(400.000000, 716.000000)">
                        <g id="编组-14" transform="translate(42.000000, 73.000000)">
                            <g id="编组-10" transform="translate(0.000000, 416.000000)">
                                <g id="编组-9" transform="translate(0.000000, 36.000000)">
                                    <g id="briefcase备份-2" transform="translate(0.000000, 4.000000)">
                                        <path
                                            d="M8.39999999,2.94736843 L5.60000001,2.94736843 L5.60000001,1.47368422 L8.39999999,1.47368422 M12.6,2.94736843 L9.8,2.94736843 L9.8,1.47368422 L8.39999999,0 L5.60000001,0 L4.2,1.47368422 L4.2,2.94736843 L1.40000001,2.94736843 C0.62300001,2.94736843 0,3.60315789 0,4.42105263 L0,12.5263158 C0,12.9171612 0.147499578,13.2919985 0.41005051,13.5683679 C0.672601442,13.8447373 1.02869692,14 1.40000001,14 L12.6,14 C12.9713031,14 13.3273986,13.8447373 13.5899495,13.5683679 C13.8525004,13.2919985 14,12.9171612 14,12.5263158 L14,4.42105263 C14,4.03020728 13.8525004,3.65536993 13.5899495,3.37900053 C13.3273986,3.10263113 12.9713031,2.94736842 12.6,2.94736843 L12.6,2.94736843 Z"
                                            id="形状"
                                        ></path>
                                    </g>
                                </g>
                            </g>
                        </g>
                    </g>
                </g>
            </g>
        </svg>
    );
};
